import { HblTeamStatistics } from 'components/sports/hbl/views/HblTeamStatistics';
import { isParalympic, CompetitionFromStore } from "helpers/utils";

const RenderPeriods = ({ data, statsTOT }) => {
    return (
        <HblTeamStatistics data={data?.results} stats={statsTOT} />
    )
}

function HblTeamStats({ data }) {
    const competition = CompetitionFromStore();
    let statsTOT;

    statsTOT = [
        { code: 'EXC', header: 'LabelBlueCards' },
        { code: 'RC', header: 'LabelRedCards' },
        { code: 'TMS', header: 'LabelTwoMinuteS' },
        { code: 'YC', header: 'LabelYellowCards' },
        { code: 'EG', header: 'LabelEmptyGoal', component: 'type7' },
        { code: 'BT', header: 'LabelBreakThroughs' },
        { code: 'FB', header: 'LabelFastBreaks' },
        { code: 'PTY', header: 'LabelSevenMetreShot', component: 'type7' },
        { code: 'LD', header: 'LabelNineMetreShot', component: 'type7' },
        { code: 'W', header: 'LabelWingShot', component: 'type7' },
        { code: 'SD', header: 'LabelSixMetre', component: 'type7' },
        { code: 'SHOT', header: 'LabelEfficiency', component: 'type8' },
        { code: 'SHOT', header: 'HeaderGoalsShots', component: 'type7' }
    ]

    return (
        <><RenderPeriods data={data} statsTOT={statsTOT} /></>
    );
}

export default HblTeamStats;